import React, { useRef, useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { documentsActions, fileActions } from '../../store/actions'
import { useNavigate, useLocation } from 'react-router-dom'

//// import { mainStyles, theme } from '../../styles'
// import { useStyles } from './CargarDocsStyles'
import { cargarDocsFunctions } from './CargarDocsFunctions'
import { CustomCounterAppBar, CustomAlertMaterial, InputField, CustomLoadingOverlay ,Buttons } from '../../components'

import {
    Typography,
    useMediaQuery,
    IconButton,useTheme
} from '@mui/material';
import { useTranslation } from 'react-i18next';

export default function MobileCamaraCapture(props) {
    const matches = useMediaQuery('(min-width:650px)');
    const gridContainer = {} //mainStyles.gridStyle()
     const theme = useTheme()
    const location = useLocation()
  const classes = {} //mainStyles.bodyStyles()
    const localStyles = {}//useStyles()
    const navigate = useNavigate()

    const takePicture = useRef(null)

    const [loadView, setLoadView] = useState(false)
    const [ocrErrorAlert, setOcrErrorAlert] = useState(false)
    const [metaToSend, setMetaToSend] = useState(false)
    const [showErrors, setshowErrors] = useState(false)

    const [currentStage, setCurrentStage] = useState(0)
    const [totalStage, setTotalStage] = useState(0)
    const [totalSections, setTotalSections] = useState(0)

    const [document, setDocument] = useState('')

    const [metadatos, setMetadatos] = useState([])
    const [fields, setFields] = useState([])
    const [formData, setFormData] = useState([]);
    const [activeOrder, setActiveOrder] = useState(false)

    const [transId, setTransId] = useState(null)

    const folioId = location.state.folioId
    const sectionId = location.state.sectionId
    const sections = location.state.sections
    const docName = location.state.docName
    const sectionName = location.state.sectionName
    const ocrInfo = location.state.ocrInfo
    const qrProcess = location.state.qrProcess
    const actorId = location.state.actorId
    const activeNSections = location.state.activeNSections
    const sectionsCapture = location.state.sectionsCapture
    const docTypeId = location.state.docTypeId

    const file = useSelector(state => state.FileInfo)
    const uploadSecDoc = useSelector(state => state.UploadSections)
    const uploadDoc = useSelector(state => state.UploadDocuments)
    const ocrResponse = useSelector(state => state.OcrData)
    const registeredData = useSelector(state => state.MetadaData)
    const dispatch = useDispatch();
    const { t } = useTranslation();

    const dataToSend = {
        B64Content: document,
        FileId: folioId,
        Actor_Id: actorId,
        SkipActor: null,
        SectionId: sectionId,
        Extension: '.jpg',
        Skip: false,
        SkipReason: null,
        Metadata: metadatos.length > 0 ? metadatos : null, //pending
        ContinueWorkFlow: false, //to upload all files before moving
        Geolocation: null, //Pending
        DeferLoad: false // heavy file, true to load on backgroud 
    }


    const dataforMetadata = {
        File_id: folioId,
        Carga: {
            Referencia: folioId.toString(),
            TransactionId: transId,
            EsBolqueFin: sections.length === totalSections && sections.length > 1 ? true
                : sections.length != totalSections && sections.length > 1 ? false : true,
            TipoDocumento: docName,
            Seccion: sectionName,
            Imagenes: [
                {
                    B64: document,
                    Extension: '.jpg'
                }
            ],
            Metadatos: null
        }
    }

    const goBack = () => {
        const noCurentCapture = (location.state.noCurentCapture + 1)
        const nextComponent = 'CargarDocsComponent'
        cargarDocsFunctions.nextIndocLoading({ navigate, folioId, nextComponent, qrProcess, ocrInfo, activeNSections, sectionsCapture, noCurentCapture })
    }

    const goBackpdf = () => {
        const nextComponent = 'CargarDocsComponent'
        const pdf = true
        cargarDocsFunctions.nextIndocLoading({ navigate, folioId, sectionId, nextComponent, docName, sectionName, ocrInfo, qrProcess, pdf })
    }

    useEffect(() => {
        dispatch(fileActions.GetFileInfo(location.state.folioId))
        takePicture.current.click()
        console.log("Docname**************: ,docName", docName)
        setFields(cargarDocsFunctions.getNewFieldName(docName))
    }, [])

    useEffect(() => {
        setLoadView(file.loading)
        if (file.items != undefined) {
            setCurrentStage(file.items.Stage.CurrentStageGroup)
            setTotalStage(file.items.Stage.TotalStageGroups)
        }
    }, [file])

    const turnTob64 = (e, event) => {
        event.target.value = null
        let base64 = e.target.result
        base64 = base64.split(',')
        setDocument(base64[1])
    }

    let getFileLoaded = (event) => {
        if (event.target.files && event.target.files[0]) {
            let readerToSend = new FileReader()
            readerToSend.onload = (e) => {
                turnTob64(e, event)
            }
            readerToSend.readAsDataURL(event.target.files[0]); //this is to read as b64
        }
    }
    const sendDocAction = () => {
        setLoadView(true)
        dispatch(documentsActions.CargaSeccion(dataToSend))
    }

    const askforTransactionId = () => {
        setLoadView(true)
        dispatch(documentsActions.CargaDocumento(dataforMetadata))
    }

    useEffect(() => {
        if (document != '' && ocrInfo.ocr == 0) {
            sendDocAction()
        } else if (document != '' && ocrInfo.ocr != 0) {
            askforTransactionId()
        }
    }, [document])

    useEffect(() => {
        if (uploadSecDoc.items != undefined && uploadSecDoc.items?.Result != undefined && loadView) {
            if ((uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined) && !metaToSend) {
                goBack()
            } else if ((uploadSecDoc.items.Result?.Id != null || uploadSecDoc.items.Result?.Id != undefined) && metaToSend) {
                dispatch(documentsActions.RegisterMetadata({
                    Document_Id: uploadSecDoc.items.Result.Id,
                    Metadata: metadatos
                }))
            }
        } if (uploadSecDoc.error != undefined && loadView) {
            setLoadView(false)
            alert(uploadSecDoc.error)
        }
    }, [uploadSecDoc])

    useEffect(() => {
        if (registeredData.items && loadView && metaToSend) {
            goBack()
        }
        if (registeredData.error != undefined && loadView && metaToSend) {
            alert(registeredData.error)
        }
    }, [registeredData])

    useEffect(() => {
        if (uploadDoc.items != undefined && uploadDoc.items?.TransactionId != null && loadView) {
            // setTransId(uploadDoc.items.TransactionId)
            localStorage.setItem('TransactionId', uploadDoc.items.TransactionId)//Almacenar TransactionId
            // dispatch(documentsActions.GetOcrData(uploadDoc.items.TransactionId))
            let requestOcr = {
                File_id: folioId,
                DocumentType_Id: docTypeId,
                TransactionId: uploadDoc.items.TransactionId
            }
            console.log("requestOcr......*************: ", requestOcr)
            dispatch(documentsActions.GetOcrData(requestOcr))

        } if (uploadDoc.error != undefined && loadView) {
            setLoadView(false)
            alert(uploadDoc.error)
        }
    }, [uploadDoc])

    useEffect(() => {
        if (ocrResponse.items != undefined && ocrResponse.items?.Metadatos != null && loadView) {
            if (ocrResponse.items.Metadatos[0].Name == "ProcessError") {
                setOcrErrorAlert(true)
                setLoadView(false)
            } else if (ocrResponse.items.Metadatos[0].Name != "ProcessError") {
                setMetadatos(ocrResponse.items.Metadatos)
            }
        } if (ocrResponse.error != undefined && loadView) {
            setLoadView(false)
            alert(ocrResponse.error)
        }
    }, [ocrResponse])


    useEffect(() => {
        if (metadatos.length > 0 && loadView && !metaToSend) {
            let newData = metadatos.map((data, index) => {
                console.log("data: ", data)
                let findValues = fields?.find(field => data.Name === field.OnlineFieldName)
                console.log("findValues: ", findValues)
                return {
                    GroupName: data.GroupName,
                    Value: data.Value,
                    Name: findValues != undefined
                        && findValues != null && findValues != "" ? findValues?.FieldQuestionName : data.Name,
                    Label: findValues != undefined
                        && findValues != null && findValues != "" ? findValues?.FieldName : data.Name,
                    Sequence: findValues != undefined
                        && findValues != null && findValues != "" ? findValues?.Sequence : index,
                }
            })
            let orderArray = newData.sort((a, b) => a.Sequence - b.Sequence)
            setFormData(orderArray)
        } else if (metadatos.length > 0 && loadView && metaToSend) {
            setFormData([])
            sendDocAction()
        }
    }, [metadatos])

    // useEffect(() => {
    //     if (fields.length > 0) {
    //         // console.log("formData-----Origen de datos: ", formData)
    //         if (formData.length > 0 && activeOrder == false) {
    //             let newMetaData = fields.map((data) => {
    //                 // console.log("formData-----Origen de datos: ", formData)
    //                 let newObjFind = formData.find((item) => item.Name === data.OnlineFieldName)

    //                 return {
    //                     GroupName: newObjFind?.GroupName,
    //                     Value: newObjFind?.Value,
    //                     Name: newObjFind?.Name,
    //                     Label: newObjFind?.Label,
    //                     Sequence: data.Sequence
    //                 }
    //             })
    //             // console.log("Array sin orden:----------------------- ", newMetaData)
    //             let orderArray = newMetaData.sort((a, b) => a.Sequence - b.Sequence)
    //             // console.log("Metdatos con ordenamiento:------------ ", orderArray)
    //             setActiveOrder(true)
    //             setFormData(orderArray)
    //         }
    //     }
    // }, [fields, formData])

    useEffect(() => {
        if (formData.length > 0 && loadView) {
            setLoadView(false)
        }
    }, [formData])

    const setNewMetadata = () => {
        setLoadView(true)
        const newMeta = formData.map((fields) => {
            return {
                GroupName: fields.GroupName,
                Value: fields.Value,
                Name: fields.Name
            }
        })
        setMetaToSend(true)
        setMetadatos(newMeta)
    }

    return (
        <div className={gridContainer.container}>
            <div className={gridContainer.leftColumn}></div>
            <div>
                {loadView && <CustomLoadingOverlay active={loadView} text={t("general_loading_message")} />}
                <input
                    type='file'
                    hidden
                    accept='image/*'
                    capture='environment'
                    onChange={getFileLoaded}
                    ref={takePicture} />
                <CustomCounterAppBar
                    initialStep={currentStage}
                    endingStep={totalStage}
                    viewMenu={qrProcess ? false : true}
                />
                <div className={gridContainer.centerColumn}>

                    {formData.length > 0 && ocrInfo.ocr != 0
                        && <div className={localStyles.modal}>
                            <div className={localStyles.helpModalTextForm}>
                                <Typography variant="body1" gutterBottom>
                                  {t("cargar_data_capture")}
                                </Typography>
                                <Typography variant="subtitle2" className={localStyles.p}>
                                  {t("capture_verification")}
                                </Typography>
                            </div>
                            <div className={localStyles.form}>
                                {formData.map((input, index) => {
                                    return <div className={localStyles.inputField}>
                                        <InputField
                                            type='Text'
                                            variant='outlined'
                                            label={input.Label}
                                            name={input.Name}
                                            value={input.Value}
                                            onChange={(e) => {
                                                let newArr = [...formData]
                                                newArr[index].Value = e.target.value
                                                setFormData(newArr)
                                                console.log('formChanges', formData)
                                                // Edit value of an Object inside an Array 
                                            }}
                                        />
                                    </div>
                                })}
                            </div>
                            <Buttons
                                background_color={theme.palette.primary.main}
                                text_color='#FFFFFF'
                                border_color={theme.palette.primary.main}
                                text={t("general_accept")}
                                type='button'
                                className={localStyles.cargarMetaBtn}
                                click={setNewMetadata}
                            />
                        </div>}

                </div>
                <CustomAlertMaterial
                    title={t("cargar_recapture")}
                    body={t("cargar_data_extraction_failed_attach")}
                    closeAction={() => setOcrErrorAlert(false)}
                    open={ocrErrorAlert}
                    leftButtonText={t("cargar_upload_pdf")}
                    leftButtonAction={goBackpdf}
                    rightButtonText={t("cargar_recapture")}
                    rightButtonAction={() => {
                        setDocument('')
                        setMetadatos([])
                        takePicture.current.click()
                        setOcrErrorAlert(false)
                    }}
                />
            </div>
            <div className={gridContainer.rightColumn}></div>
        </div>
    )
}
